<template>
  <ppt-modal class="sharable-url-modal">
    <header slot="header">
      <button class="close" data-dismiss="modal"><span>&times;</span></button>
    </header>
    <section slot="body">
      <div v-if="!url">
        <p v-if="approximateWaitTime">Creating the sharable URL. This could take {{ approximateWaitTime }}+ seconds.</p>
        <p v-else>Creating the sharable URL...</p>
        <img v-if="!url" src="/static/loading.svg" width="100">
      </div>
      <div v-else>
        <p>If someone visits this URL, they will see the exact same screen you are seeing. It's nice to be able to send it to friends, or share it in poker forums.</p>
        <p>If they aren't logged in, they'll be in readonly mode. If they are logged in, they'll be able to use the tool in exactly the same way you are.</p>
        <hr>
        <div class="form-group">
          <input
            type="url"
            v-bind:value="url"
            class="form-control input-lg"
            autofocus
            v-on:focus="$event.target.select()"
          >
        </div>
      </div>
    </section>
  </ppt-modal>
</template>

<script>
import PPTModal from '@/components/utilities/modal';

export default {
  name: 'sharable-url-modal',
  components: {
    'ppt-modal': PPTModal,
  },
  props: ['url', 'approximateWaitTime'],
};
</script>

<style lang="scss" scoped>
  .sharable-url-modal {
    font-size: 18px;

    input[type="url"] {
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sharable-url-modal.vue